import React, { Component } from "react";
import { Button, Form, Typography, Input, Result, notification, Spin } from 'antd';
import './forget.module.css'
import { post } from '../../utils/http';
import api from "../../utils/api";
import { encrypt } from "../../services/AuthService";
import { LoadingOutlined } from '@ant-design/icons';
import styles from './login.module.css';
import { commonUtil } from '../../utils/commonUtil';

const { Search } = Input;
const { Title } = Typography;

class ForgetPwd extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            email: "",
            code: "",
            newPwd: "",
            checkPwd: "",
            status: ["process", "wait", "wait"],
            searchLoading: false,
            loading: false,
            result: false,
            publicKey: "",
            disabledSubmit:true
        }
    }

    //send OTP to email or mobile
    getCode = (value) => {
        var _this = this;
        if(commonUtil.isEmail(value)){
            if (this.state.publicKey !== "") {
                this.sendEmailOTP(value);
            } else {
                post(api.getPublicKey).then( response => {
                    _this.setState({ publicKey: response, disabledSubmit:false }, () => {
                        _this.sendEmailOTP(value);
                    })
                }).catch(function (error) {
                    notification['error']({
                        message: error
                    })
                })
            }
        }else if(commonUtil.isMobile(value)){
            this.sendMobileOTP(value);
        }
    }

    sendMobileOTP = (value) => {
        this.setState({ email: value, searchLoading: true });
        const subData = { "accountId": value, "detailId": "", "otp": "", "needChangePassword":false };
        var _this = this;
        post(api.telepinRequestTAC, subData).then( response => {
            console.log(response)
            _this.setState({ searchLoading: false,disabledSubmit: false});
            notification['success']({
                message: "We send a code to your mobile number, please input it in the next input box.",
            });
            
        }).catch(function (error) {
            _this.setState({ searchLoading: false });
            if(commonUtil.isJSON(error)){
                notification['error']({
                    message: JSON.stringify(error.message),
                });
            }else{
                notification['error']({
                    message: JSON.stringify(error),
                });
            }
        })
    }

    sendEmailOTP = (value) => {
        this.setState({ email: value, searchLoading: true });
        var sendData = new FormData();
        sendData.append("email", encrypt(value, this.state.publicKey))
        var _this = this;
        post(api.sendCode, sendData).then(function (response) {
            _this.setState({ searchLoading: false,disabledSubmit: false });
            notification['success']({
                message: "We send a code to your email box, please input it in the next input box.",
            });
        }).catch(function (error) {
            notification['error']({
                message: error,
            });
            _this.setState({ searchLoading: false })

        })
    };

    verifyOTP = () => {

        if(commonUtil.isEmail(this.state.email)){
            //verify email OTP
            const validData = { "email": encrypt(this.state.email, this.state.publicKey), "code": encrypt(this.state.code, this.state.publicKey) };
            let _this = this;
            post(api.validCode, validData).then(function (response) {
                _this.setState({ current: 1, status: ["finish", "process", "wait"] })
            }).catch(function (error) {
                notification["error"]({
                    message: error
                })
                _this.setState({ status: ["error", "wait", "wait"] })
            })
        }else if(commonUtil.isMobile(this.state.email)){
            //verify mobile OTP
            const validData = { "accountId": this.state.email, "detailId": "", "otp": this.state.code, "needChangePassword":false };
            var _this = this;
            post(api.telepinVerifyTAC, validData).then( response => {
                _this.setState({ searchLoading: false, current: 2  });
                notification['success']({
                    message: "Verify OTP success. please try login with you new temp password",
                });
                
            }).catch(function (error) {
                if(commonUtil.isJSON(error)){
                    notification['error']({
                        message: JSON.stringify(error.message),
                    });
                }else{
                    notification['error']({
                        message: JSON.stringify(error),
                    });
                }
            })
        }
    };

    handleSubmit = () => {
        const subData = { "email": encrypt(this.state.email, this.state.publicKey), "newPwd": encrypt(this.state.newPwd, this.state.publicKey), "checkPwd": encrypt(this.state.checkPwd, this.state.publicKey) };
        var _this = this;
        post(api.forgetPwd, subData).then(function (response) {
            _this.setState({ current: 9, result: true, status: ["finish", "finish", "finish"] })
        }).catch(function (error) {
            _this.setState({ current: 9, result: false, status: ["finish", "finish", "error"] })
        })
    }

    goToLogin = () => {
        this.props.history.push("/login");
    }

    getContent = (currentPage, result) => {
        if (currentPage === 0) {
            return (<div>
                 <Title className={styles.title} style={{ color: "#a52387" }}>DASH Portal</Title>
                {/* Mobile or email user send OTP */}
                <p>
                    Please input your mobile No or Email, we will send an OTP to you.
                </p>
                <Form
                    style={{ marginLeft: '100px' }}
                    name="basic"
                    labelCol={{
                        span: 6,
                    }}
                    wrapperCol={{
                        span: 12,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Email/Mobile"
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your email/mobile!',
                            },
                        ]}
                    >
                        <Search
                            placeholder="Registered mobile(e.g. 65xxx) or email"
                            enterButton="Send code"
                            onSearch={this.getCode}
                            size="large"
                            loading={this.state.searchLoading}
                        />
                    </Form.Item>

                    <Form.Item
                        label="OTP"
                        name="valid code"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your OTP!',
                            },
                        ]}
                    >
                        <Input
                            onChange={(event) => this.setState({ code: event.target.value })}
                            placeholder="Please input OTP"
                            size="large"
                            maxLength={6}
                        />
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                            offset: 4,
                            span: 16,
                        }}
                    >
                        <div>
                            <Button onClick={this.goToLogin} type="primary" htmlType="button" style={{marginRight:'30px'}}>
                                    Back
                            </Button>
                            {!this.state.loading && <Button disabled={this.state.disabledSubmit} onClick={this.verifyOTP} type="primary" htmlType="submit" style={{color:'white'}}>
                                Submit
                            </Button>}
                            {this.state.loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#a52387" }} spin />} />}
                        </div>
                        
                    </Form.Item>
                </Form>
            </div>)
        } else if (currentPage == 1) {
            //email user verify otp success
            return (<div>
                 <Title className={styles.title} style={{ color: "#a52387" }}>DASH Portal</Title>
                <p>
                    Please input your new password.
                </p>
                <Form
                    style={{ marginLeft: '100px' }}
                    name="basic"
                    labelCol={{
                        span: 6,
                    }}
                    wrapperCol={{
                        span: 12,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="New Password"
                        name="new password"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your new password!',
                            },
                        ]}
                    >
                        <Input.Password
                            onChange={(event) => this.setState({ newPwd: event.target.value })}
                            placeholder="please input new password"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Confirm Password"
                        name="check password"
                        rules={[
                            {
                                required: true,
                                message: 'Please input check password!',
                            },
                        ]}
                    >
                        <Input.Password
                            onChange={(event) => this.setState({ checkPwd: event.target.value })}
                            placeholder="please confirm new password"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                            offset: 4,
                            span: 16,
                        }}>

                        <div>
                            {!this.state.loading && <Button onClick={this.handleSubmit} type="primary" htmlType="submit">
                                Submit
                            </Button>}
                            {this.state.loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#a52387" }} spin />} />}
                        </div>
                      

                    </Form.Item>
                </Form>
            </div>);
        }else  if (currentPage === 2) {
            //mobile user reset password success
            return (<div>
                <Title className={styles.title} style={{ color: "#a52387" }}>DASH Portal</Title>
                    <p>
                        <b>Reset Password Success!</b>  <div></div>A new temporary password has been sent to your registered mobile No <div></div> <div style={{color:'#1890ff',cursor:'pointer'}} onClick={this.goToLogin} >Login with your password.</div>
                    </p>
                </div>
               )

        } else {
            if (result) {
                return (<Result
                    status="success"
                    title="Change your password successfully!"
                    extra={[
                        <Button onClick={this.goToLogin} type="primary" key="console">
                            Go to login
                        </Button>
                    ]}
                />)
            } else {
                return (<Result
                    status="error"
                    title="Fail to change your password!"
                    extra={[
                        <Button onClick={() => { this.setState({ current: 1 }) }} type="primary" key="console">
                            Remodify
                        </Button>,
                    ]}
                />)
            }
        }
    }

    render() {
        return (
            <div>
                <div style={{ display: "flex", margin: "0 auto", alignItems: 'center', width: '1100px', height: '600px' }}>
                    <div>
                        <div style={{ height: '350px', width: '1100px', textAlign: 'center', marginTop: 20, padding: 60, fontSize: 18, borderRadius: 2 }} >{this.getContent(this.state.current, this.state.result)}</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ForgetPwd;